/** Row background for rows that are not persisted yet (ghost rows). */
export const ghostRowClassName = 'bg-bg-accent/20';
